module.exports = __webpack_public_path__ + "public/images/apple.9050bbb371fae31034146b579879fd8f.png";